<script setup lang="ts">
const navbarRef = ref()
const isDrawerOpen = computed(() => navbarRef.value?.showDrawer || false)
</script>

<template>
  <div class="overflow-hidden">
    <LayoutPageNavbar
      ref="navbarRef"
      :class="{
        'max-h-[80vh]': isDrawerOpen,
      }"
      class="md:h-[100px] md:max-h-[100px]"
    />
    <LayoutPageContent>
      <slot />
    </LayoutPageContent>
    <LayoutPageFooter />
  </div>
</template>
